import { useLazyQuery, useMutation } from '@apollo/client';
import './WorkshopLibrary.scss';
import { useDispatch } from 'react-redux';
import ToasterWithMessage from '../toaster';
import { FC, SyntheticEvent, useEffect, useRef, useState } from 'react';
import { clickedWorkshopDetails, singleObjectType } from '../../pages/Workshop/Workshop';
import { useAppSelector } from '../../redux/app/hooks';
import images from '../../assets/images';
import { calculateDays, calculateDuration, formatDuration, formatSavedDate, formatTime, getFormattedDateInfo, getScreenDimensions } from '../../utils/helper';
import { CircularProgress, Menu, MenuItem, styled, Tab, Tabs, Tooltip } from '@mui/material';
import { ALERT_MESSAGE_ALREADY_IN_MEETING, FETCH_POLICY, FETCH_POLICY_NO_CACHE, JITSI, SCHOOL_ADMIN, TEACHER_ROLE } from '../../utils/constants';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import { DELETE_WORKSHOP, GET_WORKSHOP_BY_ID } from '../../pages/Workshop/api/WorkshopQuery';
import JoinWorkshop from '../JoinWorkshop/JoinWorkshop';
import { getUserMedia } from '../../utils/webRTCHelper';
import { useGlobalState } from '../../MeetContext/MeetContext';
import WarningPopup from '../WarningPopup/WarningPopup';
import { READ_NOTIFICATIONS } from '../../pages/AdminDashboard/api/AdminDashboardQuery';
import { setRefetchNotification } from '../../redux/slices/authSlice';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getChimeParticipants } from '../../Chime/helpers/get-participants';
import MaterialActionsOverlay, { MenuItemType } from '../ActionsOverlay/MaterialActionsOverlay';


interface propsType{
    setClickedVideoDescription: (val: string) => void;
    setClickedVideoUrl: (val: string) => void;
    setClickedVideoData: any;
    setShowCreateScheduling: (val: boolean) => void;
    upcomingSessionList: clickedWorkshopDetails[];
    singleSessionDetail: clickedWorkshopDetails | undefined;
    setSingleSessionDetail: (val: clickedWorkshopDetails|undefined) => void;
    setClickedSessionDetails?: any;
    clickedSessionDetails?: clickedWorkshopDetails | undefined;
    setIsDeleted: (val: boolean) => void;
    fetchUpcomingSessions: any;
    isClickedSessionDetail: boolean;
    setIsClickedSessionDetail: (val: boolean) => void;
    setEditClicked: (val:boolean) => void;
    sessionEnded: boolean;
    setSessionEnded: (val: boolean) => void;
    loading: boolean;
    allSavedUploadedVideosList: singleObjectType[] | undefined;
    activeTab: number;
    setActiveTab: (val: number) => void;
    getAllVideoLoading: boolean;
    setIsAdminButtonClicked: (val: boolean) => void;
    isAdminButtonClicked : boolean;
    setIsTeacherButtonClicked : (val : boolean) => void;
    isTeacherButtonClicked : boolean;
    SetIsMoreClick : (val: boolean) => void;
    isMoreClick : boolean;
    handleStartMeeting: any
    handleJoinMeeting : any
    fetchSessionDetails : () => void;
    hasMore: boolean;
    setHasMore: (val: boolean) => void;
    loadMore: () => void;
    totalCount: number;
    setAllSavedUploadedVideosList: (val: singleObjectType[]) => void;
    setOffset: (val: number) => void;
    handleClickScheduleMeeting: () => void;
    isVideoUploaded: boolean;
    isSearchClick: boolean;
    setIsEditVideo: (val: boolean) => void;
    setWorkshopOpen: (val: boolean) => void;
    setIsWorkshopUploadOpen: (val: boolean) => void;
    setSelectedSingleVideo: (val: singleObjectType | null) => void;
}

const StyledTabs = styled(Tabs)(({theme}) => ({
    '& .MuiTabs-indicator': { display: 'none' }
}))


// Custom styled Tab component
const CustomTab = styled(Tab)(({ theme }) => ({
    fontFamily: 'var(--font-inter)',
    fontWeight: 600,
    fontSize: getScreenDimensions()?.isMobileScreen ? 10 : 12,
    lineHeight: '14.52px',
    textTransform: 'capitalize',
    padding: '0 var(--padding-3xs)',
    flex: 1,
    display: 'flex',
    minHeight: '30px',
    // maxWidth: '140px',
    columnGap: '10px',
    borderRadius: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '40px',
    '&.Mui-selected': {
      color: 'white',
      backgroundColor: '#0B74BB'
    },
    '&:not(.Mui-selected)': {
      color: 'black',
      backgroundColor: '#F0F3F5'
    },
  }));

const WorkshopLibrary:FC<propsType> = ({
    setClickedVideoUrl,
    setClickedVideoDescription,
    setClickedVideoData,
    loading,
    sessionEnded,
    setSessionEnded,
    setShowCreateScheduling,
    upcomingSessionList,
    singleSessionDetail,
    setSingleSessionDetail,
    setClickedSessionDetails,
    clickedSessionDetails,
    setIsDeleted,
    fetchUpcomingSessions,
    isClickedSessionDetail,
    setIsClickedSessionDetail,
    allSavedUploadedVideosList,
    setEditClicked,
    activeTab,
    setActiveTab,
    getAllVideoLoading,
    setIsAdminButtonClicked,
    isAdminButtonClicked ,
    setIsTeacherButtonClicked ,
    isTeacherButtonClicked,
    SetIsMoreClick ,
    isMoreClick,
    handleStartMeeting,
    handleJoinMeeting ,
    fetchSessionDetails,
    hasMore,
    setHasMore,
    loadMore,
    totalCount,
    setOffset,
    setAllSavedUploadedVideosList,
    handleClickScheduleMeeting,
    isVideoUploaded,
    isSearchClick,
    setIsEditVideo,
    setIsWorkshopUploadOpen,
    setWorkshopOpen,
    setSelectedSingleVideo
}) => {


    const dispatch = useDispatch();
    const {setIsMeetingEndByHost} = useGlobalState();
    const {error, success} = ToasterWithMessage();
    const {calendarSymbol, clockSymbol, sandWatch, WhiteMoreIcon, DeleteGif, MoreIcon, ResetCode, DeleteClass, videoPlayIcon, ScheduleWorkshopGif} = images;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [openMenu, setOpenMenu] = useState<boolean>(false);
    const { role, meetService } = useAppSelector((state) => state.auth);
    const [daysleftValue, setDaysleftValue] = useState('');
    const [startTime, setStartTime] = useState('');
    const [duration, setDuration] = useState('');
    const descriptionRef = useRef<HTMLDivElement | null>(null);
    const [isOverflow, setIsOverflow] = useState(false)
    const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
    const [openWarningPopup, setOpenWarningPopup] = useState<boolean>(false);
    const [isDescOverflow,setIsDescOverflow] = useState<boolean[]>([]);
    const [videoAnchorEl, setVideoAnchorEl] = useState<HTMLElement | null>(null);
    const [openOverlay, setOpenOverlay] = useState<boolean>(false);
    const [videoDurations, setVideoDurations] = useState<{ [key: string]: number }>({});
    const videoDescriptionRef = useRef<(HTMLSpanElement | null)[]>([]);
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const profile = useAppSelector((state) => state.auth.adminProfile);
    const meetingService = meetService;
    const [warningMessage, setWarningMessage] = useState<string>('');
    const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase());
    const isJoined = localStorage.getItem("isJoined") || '';

    const closeWarnPopup = () => {
        setOpenWarningPopup(false);
        setWarningMessage("");
      }

    const handleChangeTab = (_e: SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
        setAllSavedUploadedVideosList([]);
        setOffset(0);
    }

    const getPreviewStream = async() => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true});
            console.log("[Log] stream", stream, stream?.getTracks());
            stream.getTracks().forEach((track) => track.stop());
            return stream;
        } catch (err: any) {
            console.log("[Log] getPreviewStream Error", err);
            let errorMessage = "Unable to access your camera or microphone. Please check your device settings and try again.";
            if (err?.name === "NotAllowedError" || err?.name === "SecurityError") {
                errorMessage = "Permission denied. Please allow camera and microphone access.";
            } else if (err?.name === "NotFoundError" || err?.name === "DevicesNotFoundError") {
                errorMessage = "No camera or microphone found. Please check your device.";
            } else if (err?.name === "NotReadableError" || err?.name === "HardwareAccessError") {
                errorMessage = "Another app is using your camera or microphone. Close the other app and try again.";
            } else if (err?.name === "OverconstrainedError") {
                errorMessage = "Your camera does not support the requested video resolution.";
            }
            setWarningMessage(errorMessage);
            setOpenWarningPopup(true);
            if (role === SCHOOL_ADMIN) {
                setIsAdminButtonClicked(false);
            } else if (role === TEACHER_ROLE) {
                setIsTeacherButtonClicked(false);
            }
        }
    };

    const [getSingleSessionDetail] = useLazyQuery(GET_WORKSHOP_BY_ID, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
            const response = data?.getWorkShopByWsId || {};
            const meetId = response?.wsCode;

            if (meetId && meetingService !== JITSI) {
                getChimeParticipants(meetId)
                    .then((participantsResponse) => {
                        response.wsParticipantsCount = participantsResponse?.Attendees ? participantsResponse.Attendees.length : 0;
                        // response.wsParticipantsCount = participants ? Object.keys(participants).length : 0;
                    })
                    .catch(() => {
                        response.wsParticipantsCount = 0;
                    })
                    .finally(() => {
                        console.log("[Log] Participants count:", response.wsParticipantsCount);
                        if (isMoreClick === false) {
                            //this state is using for start and join session card place
                            setSingleSessionDetail(response);
                        } else {
                            //this state is using for edit and delete session
                            setClickedSessionDetails({ ...response, type: "workshop" });
                        }
                    });
            } else {
                if (isMoreClick === false) {
                    //this state is using for start and join session card place
                    setSingleSessionDetail(response);
                } else {
                    //this state is using for edit and delete session
                    setClickedSessionDetails({ ...response, type: "workshop" });
                }
            }
            setSessionEnded(false);
        },
        onError: (err) => {
        if(err?.message === "Workshop has ended"){
             setSessionEnded(true);
             setTimeout(() => {
              setSingleSessionDetail(undefined);
              fetchUpcomingSessions();
            }, 5000); 
          }else {
            error(err?.message)
          }
        }
      });

    const [deleteWorkshop] = useMutation(DELETE_WORKSHOP, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
            setShowCreateScheduling(false);
            setIsDeleted(true);
            success("Deleted successfully");
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    const [readNotification] = useMutation(READ_NOTIFICATIONS, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: () => {
            dispatch(setRefetchNotification({ refetchNotification: true }));
        },
        onError: (err) => {
            console.log("Error", err?.message);
        }
    })  

    //set the particular data when click card
    const onClickSingleSession = (cardItem: clickedWorkshopDetails) => {
    setIsClickedSessionDetail(true);
    localStorage.setItem("workshopId",cardItem?.wsId);
    SetIsMoreClick(false);
    if(openMenu === false){
        getSingleSessionDetail({
            variables: {
                input: {
                    wsId: cardItem?.wsId
                }
            }
        })
        if (cardItem?.feedsByWsId?.nodes[0]?.fId && profile?.getCurrentUser?.nodes[0]?.uId) {
            readNotification({
                variables: {
                    fId: cardItem?.feedsByWsId?.nodes[0]?.fId,
                    uId: profile?.getCurrentUser?.nodes[0]?.uId
                }
            })
        }
    }
  };

  const videoExpansion = (video: singleObjectType) => {
    setClickedVideoUrl(video?.seUrl ? baseUrl + video?.seUrl : '');
    setClickedVideoDescription(video?.seDescription ? video?.seDescription : '');
    setClickedVideoData(video);
  }
  
  //To check the container is overflow
const checkOverflow = () => {
    if (descriptionRef.current) {
      setIsOverflow(descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight);
    }
  };

const handleCloseMenu = () => {
    setOpenMenu(false);
}

const onClickEditVideo = () => {
    setOpenOverlay(false);
    setVideoAnchorEl(null);
    setIsWorkshopUploadOpen(true);
    setWorkshopOpen(true);
    setIsEditVideo(true);
}

const handleCloseActions = () => {
    setOpenOverlay(false);
    setVideoAnchorEl(null);
    setSelectedSingleVideo(null);
}

const handleOpenOverlay = (event: React.MouseEvent<HTMLElement>, session?: singleObjectType) => {
    event.stopPropagation();
    setVideoAnchorEl(event.currentTarget);
    setOpenOverlay(true);
  
    if (session) {
        setSelectedSingleVideo(session);
    }
};

const sessionMenuItems: MenuItemType[] = [
    { label: "Edit", onClick: () => onClickEditVideo()}
];

const onClickEditOption = () => {
    setEditClicked(true);
    handleCloseMenu();
    setShowCreateScheduling(true);
}

const onClickDeleteScheduleOption = () => {
    handleCloseMenu();
    setOpenConfirmationPopup(true);
}




    const handleClickStartButton = async () => {
        setIsAdminButtonClicked(true);
        if (meetingService === JITSI) {
            handleStartMeeting();
        } else {
            const stream = await getPreviewStream();
            if (stream) {
                handleStartMeeting(stream);
            }
        }
    };

    const handleClickJoinButton = async () => {
        if (role === SCHOOL_ADMIN) {
            setIsAdminButtonClicked(true);
        } else if (role === TEACHER_ROLE) {
            setIsTeacherButtonClicked(true);
        }
        if (meetingService === JITSI) {
            handleJoinMeeting();
        } else {
            const stream = await getPreviewStream();
            if (stream) {
                handleJoinMeeting(stream);
            }
        };
    }


  const checkOverflowVideoDescription = (index:number) => {
    if(videoDescriptionRef.current[index]){
      const overflow = (videoDescriptionRef.current[index]!.scrollHeight - 1) > videoDescriptionRef.current[index]!.clientHeight;
      setIsDescOverflow(prev => {
                  const newOverflow = [...prev];
                  newOverflow[index] = overflow;
                  return newOverflow;
      });
    }
  }
  
const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    deleteWorkshop({
        variables: {
            input: {
                wsId: clickedSessionDetails?.wsId
            },
            ...(meetService === JITSI ? { meetingType: "JITSI" } : {}),
        }
    });
  }

  const onNoButtonClick = () => {
      setOpenConfirmationPopup(false);
  }

  //To get the duration of video
    const handleLoadedMetadata = (event: React.SyntheticEvent<HTMLVideoElement>, videoPath: string) => {
        const videoElement = event.currentTarget;
        const duration = videoElement.duration;
        videoElement.currentTime = 1.2;
        setVideoDurations(prevDurations => ({
            ...prevDurations,
            [videoPath]: duration,
        }));
    };

const onClickMoreIcon = (event: React.MouseEvent<HTMLElement>,item: clickedWorkshopDetails) => {
    event.stopPropagation(); // Stop propagation to prevent triggering parent click
    setAnchorEl(event.currentTarget);
    SetIsMoreClick(true);
    getSingleSessionDetail({
        variables: {
            input: {
                wsId: item?.wsId
            }
        }
    })
    // setClickedSessionDetails(item)
    setOpenMenu(true);
  }


  useEffect(() => {
    if(singleSessionDetail){
      const daysLeft = calculateDays(singleSessionDetail?.wsStartTime);
      const startTimeFormatted = formatTime(singleSessionDetail?.wsStartTime);
      const durationFormatted = calculateDuration(singleSessionDetail?.wsStartTime, singleSessionDetail?.wsEndTime);

      setDaysleftValue(daysLeft);
      setStartTime(startTimeFormatted);
      setDuration(durationFormatted);
      checkOverflow();
      const interval = setInterval(() => {
        fetchSessionDetails();
      }, 15000); // 60000 ms = 1 minute

      return () => clearInterval(interval);
    }
  },[singleSessionDetail])
 
  //To check overflow in resize 
  useEffect(() => {
    if (allSavedUploadedVideosList) {
        allSavedUploadedVideosList?.forEach((_, index) => {
            checkOverflowVideoDescription(index); // Check overflow for each classroom name
        });
    }
    const handleResize = () => {
        allSavedUploadedVideosList?.forEach((_, index) => {
            checkOverflowVideoDescription(index);
        });
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, [allSavedUploadedVideosList]);

  useEffect(() => {
    // set false value for initial render
    setIsMeetingEndByHost(false);
    if(role === SCHOOL_ADMIN){
        setIsAdminButtonClicked(false);
    }else if(role === TEACHER_ROLE){
        setIsTeacherButtonClicked(false);
    }
  },[]);

  const isServerUrlReady = !singleSessionDetail?.meetingType || (singleSessionDetail?.meetingType === "JITSI" && singleSessionDetail?.serverUrl);

  const titleRef = useRef<HTMLDivElement | null>(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);

  // Function to check if ellipsis is active
  const handleMouseEnter = () => {
      if (titleRef.current) {
          const isEllipsis = titleRef.current.scrollWidth > titleRef.current.clientWidth;
          setIsEllipsisActive(isEllipsis);
      }
  };
  
  return (
    <div className='workShopLibraryMainContainer' style={{marginBottom : (!loading) && (singleSessionDetail?.wsId && (role === TEACHER_ROLE)) ? '110px' : ''}}>
        {
            (!loading) && (singleSessionDetail?.wsId && (role === TEACHER_ROLE)) ?
                <JoinWorkshop setIsTeacherButtonClicked = {setIsTeacherButtonClicked} setSingleSessionDetail={setSingleSessionDetail} singleSessionDetail ={singleSessionDetail} handleJoinMeeting={handleClickJoinButton} isTeacherButtonClicked ={isTeacherButtonClicked} /> 
        :
            <div className='sessionsListContainer'>
                {(!isSearchClick) && (
                    <div className='upcomingSessionMainContainer' style={{ height: singleSessionDetail ? '220px' : '' }}>
                        {
                            (singleSessionDetail?.wsId && (role === SCHOOL_ADMIN)) ?
                            <>
                            <div className='singleSessionDetail'>
                                <div className='leftSideSessionDetail'>
                                    <div className='sesstionTitle'>SESSION</div>
                                    <div className='listOfSessionDetail'>
                                    <div className='listsStyle'>
                                        <div className='listStyle'>
                                            <div className='imgCtn'>
                                            <img src={calendarSymbol} alt='calendarIcon' className='sideIconStyle'/>
                                            </div>
                                            <div className='textStyle'>{daysleftValue}</div>
                                        </div>
                                        <div className='listStyle'>
                                            <div className='imgCtn'>
                                            <img src={clockSymbol} alt='clockIcon' className='sideIconStyle'/>
                                            </div>
                                            <div className='textStyle'>{startTime}</div>
                                        </div>
                                        <div className='listStyle'>
                                            <div className='imgCtn'>
                                            <img src={sandWatch} alt='sandIcon' className='sideIconStyle'/>
                                            </div>
                                            <div className='textStyle'>{duration}</div>
                                        </div>
                                    </div>
                                    {/* <div className='minsSeparationContainer'>
                                        <div className='separationStyle'>{singleSessionDetail?.wsTeachingPeriod ? formatPart(convertToMinutes(singleSessionDetail?.wsTeachingPeriod)) : '0 min'}: Teaching</div>
                                        <div className='separationStyleDiff'>{singleSessionDetail?.wsInteractionsPeriod ? formatPart(convertToMinutes(singleSessionDetail?.wsInteractionsPeriod)):'0 min'}: Interactions</div>
                                    </div> */}
                                    </div>
                                </div>
                                <div className='rightSideSessionDetail'>
                                    <div className='lessonTopicContainer'>
                                        <div className='heaaderStyle'>
                                            <div className='headTextStyle'>LESSON TOPIC:</div>
                                            <div className='ansHeadTextStyle'>
                                            <Tooltip title={singleSessionDetail?.wsTopic} disableHoverListener={!isEllipsisActive}>
            <div 
                ref={titleRef} 
                className="headerTitle"
                onMouseEnter={handleMouseEnter} // Check on hover
                style={{ 
                    whiteSpace: "nowrap", 
                    overflow: "hidden", 
                    textOverflow: "ellipsis" 
                }}
            >
                {singleSessionDetail?.wsTopic}
            </div>
        </Tooltip>
                                                </div>
                                        </div>
                                        <Tooltip title={singleSessionDetail?.wsDescription} disableHoverListener={!isOverflow}>
                                            <div
                                            className='descriptionStyle'
                                            ref={descriptionRef}
                                            onMouseEnter={checkOverflow}>
                                            {singleSessionDetail?.wsDescription}
                                            </div>
                                        </Tooltip>
                                    </div>

                                {/* { role === SCHOOL_ADMIN ?
                                        <button className={`${(singleSessionDetail?.isActive&& !sessionEnded) ? 'sessionStartButton' : 'notReadyButtonStyle'} ${singleSessionDetail?.wsStatus === 'STARTED' ? 'sessionStartButton' : ''}`} onClick={singleSessionDetail?.wsStatus === 'STARTED' ? handleJoinMeeting : handleClickStartButton} >{
                                            sessionEnded ? `Session Ended` : (singleSessionDetail?.isActive && !(singleSessionDetail?.wsStatus === 'STARTED')) ? `Start` :singleSessionDetail?.wsStatus === 'STARTED' ? 'Join' : 'Not Ready'
                                            }
                                        </button>
                                :
                                        <div>
                                        <button className={`${(singleSessionDetail?.wsStatus === 'STARTED' && !sessionEnded) ? 'sessionJoinButton' : 'notReadyStudentButtonStyle'}`} onClick={handleClickJoinButton}>
                                            {
                                            sessionEnded ? `Session Ended` : singleSessionDetail?.wsStatus === 'STARTED' ? `Join` : 'Not Ready'
                                            }
                                        </button>
                                        {!(singleSessionDetail?.wsStatus === 'STARTED') && !sessionEnded && singleSessionDetail?.isActive &&
                                            <span className='sessionNotYetStarted'>
                                            Host has not yet started the meeting
                                            </span>
                                        }
                                        </div>
                                } */}
                                        <div>
                                        <button 
                                            className={`${(singleSessionDetail?.isActive && !sessionEnded && !isAdminButtonClicked && isServerUrlReady && ((isJoined === "left" || isJoined === ''))) ? 'sessionStartButton' : 'notReadyButtonStyle'} ${(singleSessionDetail?.wsStatus === 'STARTED' && isServerUrlReady) ? 'sessionStartButton' : ''}`} 
                                            onClick={
                                                meetingService === JITSI ?
                                                (singleSessionDetail?.wsStatus === 'STARTED' ? handleClickJoinButton : handleClickStartButton)
                                                : ((singleSessionDetail?.wsStatus === 'STARTED' && singleSessionDetail?.wsParticipantsCount === 0) ? handleClickStartButton : (singleSessionDetail?.wsStatus === 'STARTED' && singleSessionDetail?.wsParticipantsCount > 0) ? handleClickJoinButton : handleClickStartButton)
                                            }                                         >
                                        {
                                            sessionEnded ? `Session Ended` : (singleSessionDetail?.isActive && !(singleSessionDetail?.wsStatus === 'STARTED') && isServerUrlReady) ? `Start` :(singleSessionDetail?.wsStatus === 'STARTED' && isServerUrlReady) ? 'Join' : 'Not Ready'
                                        }
                                        </button>
                                        {(!(isJoined === "left" || isJoined === '')) && singleSessionDetail?.isActive && isServerUrlReady && !sessionEnded && (
                                            <span className='alreadyInMeeting'>
                                                {ALERT_MESSAGE_ALREADY_IN_MEETING}
                                            </span>
                                        )}
                                        </div>
                                </div>
                            </div>
                            </> :
                            <>
                                {
                                    upcomingSessionList?.length > 0 ? 
                                    <div className='upcomingSessionListContainer'>
                                        <div className='cardContainer'>
                                        {
                                            upcomingSessionList?.map((cardItem: clickedWorkshopDetails,index: number) => {
                                            const {dayMessage,formattedDate,dayOfWeek} = getFormattedDateInfo(cardItem?.wsStartTime);
                                            return (
                                                <div className={cardItem?.isActive ? "activeSessionForTeacher" : 'upcomingSessionCard'} onClick={() => onClickSingleSession(cardItem)} key={`${index}-${cardItem?.wsId}`}>
                                                    <div className='titleContainer'>
                                                        <div className={cardItem?.isActive ? 'activeDotContainer': 'forTeacherStyle'} style={{marginLeft: ((cardItem?.isActive)) ? '17px': ''}}>
                                                        {cardItem?.isActive ? <span className='activeDot'></span> : ''}
                                                        <div className={(cardItem?.isActive) ? 'activeTitleStyle' : 'titleStyle'} style={{color: (cardItem?.isActive ? 'white' : 'black')}}>{dayMessage}</div>
                                                        </div>
                                                        {
                                                        (role === SCHOOL_ADMIN) && cardItem?.wsStatus === "NOT_STARTED"
                                                        ? 
                                                        <div className='moreIconContainer' onClick={(e) => onClickMoreIcon(e,cardItem)}>
                                                            <img src={cardItem?.isActive ? WhiteMoreIcon : MoreIcon} alt='more' className='moreIconStyle'/>
                                                        </div>
                                                        : 
                                                        <></>
                                                        }
                                                        
                                                    </div>
                                                    <div className='dayContainer'>
                                                        <div className={(cardItem?.isActive) ? 'activeDayStyle': 'dayStyle'}>{dayOfWeek}</div>
                                                        <div className={(cardItem?.isActive) ? 'activeMonthDateStyle' : 'monthDateStyle'}>{formattedDate}</div>
                                                    </div>
                                                </div>
                                                )
                                            }
                                        )
                                        }
                                        </div>
                                        <Menu
                                                id="action-menu"
                                                MenuListProps={{
                                                    "aria-labelledby": "long-button",
                                                    disablePadding: true,
                                                }}
                                                anchorEl={anchorEl}
                                                open={openMenu}
                                                onClose={handleCloseMenu}
                                                anchorOrigin={{
                                                    vertical: 'center',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'left',
                                                }}
                                                sx={{
                                                    '& .MuiPaper-root': {
                                                        borderRadius: '5px',
                                                        boxShadow: '-10px 10px 15px 0.2px rgba(0, 0, 0, 0.05)',
                                                    },
                                                }}
                                                classes={{
                                                paper: 'menuPaperStyle'
                                                }}
                                        >
                                            <div className='menuitemContainer'>
                                                <MenuItem className='menuItemStyle' onClick={onClickEditOption}>
                                                    <img src={ResetCode} alt='resetImage'/>
                                                    <p className='labelStyle'>Edit</p>
                                                </MenuItem>
                                                <MenuItem className='menuItemStyle' onClick = {onClickDeleteScheduleOption}>
                                                    <img src={DeleteClass} alt='deleteClass'/>
                                                    <p className='labelStyle'>Delete Schedule</p>
                                                </MenuItem>
                                            </div>
                                        </Menu>
                                    </div>
                                    : <div className='noMeetings'>
                                        <img alt='gif' src={ScheduleWorkshopGif} className='scheduleMeetGifStyle'/>
                                        <div className='noMeetingsText'>{`No Meeting Available`}</div>
                                    </div>
                                }
                            </>
                        }
                    </div>
                )}
                    <div className={`savedSessionsMainContainer ${ isSearchClick ? "searchContainer" : "" }`} style={{height: (singleSessionDetail?.wsId && (role === SCHOOL_ADMIN)) ? 'calc(100% - 235px)' : 'calc(100% - 0px)'}}>
                        {(!isSearchClick) && (
                            <div>
                                {/* {((role !== SCHOOL_ADMIN) || (!getScreenDimensions()?.isMobileScreen) || (singleSessionDetail?.wsId && getScreenDimensions()?.isMobileScreen)) && ( */}
                                    <StyledTabs
                                        value={activeTab}
                                        onChange={handleChangeTab}
                                    >
                                        <CustomTab label={'All'} style={{maxWidth: '63px',}}/>
                                        <CustomTab label={'Saved Sessions'} style={{maxWidth: '150px', marginLeft: '10px'}}/>
                                        <CustomTab label={'Uploaded Sessions'} style={{maxWidth: '150px', marginLeft: '10px'}}/> 
                                    </StyledTabs>
                                {/* )} */}
                                {/* {(!singleSessionDetail?.wsId && (role === SCHOOL_ADMIN) && getScreenDimensions()?.isMobileScreen && !(allSavedUploadedVideosList && totalCount === 0 && upcomingSessionList?.length === 0 && allSavedUploadedVideosList?.length === 0)) && (
                                    <div className='createScheduleButtonContainer'>
                                        <button className='scheduleMeetBtnStyle' onClick={handleClickScheduleMeeting}>Schedule meeting</button>
                                    </div>
                                )} */}
                            </div>
                        )}
                        {
                            (allSavedUploadedVideosList && (totalCount > 0)) ?

                            <InfiniteScroll
                                dataLength={allSavedUploadedVideosList?.length || 0}
                                next={loadMore}
                                hasMore={hasMore}
                                loader={
                                    <div className="scroll-loader">
                                        <CircularProgress size={30} />
                                    </div>
                                }
                                height={`100%`}
                                className="cardContainer"
                            >
                               { allSavedUploadedVideosList?.map((videoItem: singleObjectType, index: number) => (
                                
                                    <div className='videoContainer' onClick={() => videoExpansion(videoItem)}>
                                        {
                                            (videoDurations[videoItem?.seUrl] && !isNaN(videoDurations[videoItem?.seUrl]) && videoDurations[videoItem?.seUrl]!== Infinity) ?
                                            <div className='videoDuration'>{formatDuration(videoDurations[videoItem?.seUrl])}</div>
                                            :
                                            <div className='videoDuration'>0.00</div>
                                        }
                                        <video src={videoItem?.seUrl ? `${baseUrl}${videoItem?.seUrl}${isSafariBrowser?'#t=0.001':''}` : ''} muted loop className='videoTagStyle' onCanPlay={(event) => handleLoadedMetadata(event,videoItem?.seUrl)} />
                                        <div className='descriptionContainer'>
                                            <div className='sessionMenuCtn'>
                                                <div className='savedDateStyle'>{formatSavedDate(videoItem?.createdAt)}</div>
                                                {(role === SCHOOL_ADMIN) && (videoItem?.seType === "UPLOADED") && 
                                                <button className="actionButton" onClick={(e) => handleOpenOverlay(e,videoItem)}>
                                                    <img src={MoreIcon} alt="action" className="participantActionImg" />
                                                </button>}
                                            </div>
                                            <Tooltip title={videoItem?.seDescription} disableHoverListener={!isDescOverflow[index]}>
                                                <div className='descriptionStyle' onMouseEnter={() => checkOverflowVideoDescription(index)} onMouseMove={() => checkOverflowVideoDescription(index)} ref={(el) => (videoDescriptionRef.current[index] = el)}>
                                                    {videoItem?.seDescription || videoItem?.workshopByWsId?.wsDescription}
                                                </div>
                                            </Tooltip>
                                        </div>
                                        <img src={videoPlayIcon} className='playIconStyle' alt='videoPlayIcon'/>
                                    </div>
                                ))}
                            </InfiniteScroll>

                                : (!getAllVideoLoading && <div className='noDataFoundStyle'>No data found</div>)

                            }
                        </div>
                    </div>
        } 
        <MaterialActionsOverlay
                anchorEl={videoAnchorEl}
                open={openOverlay}
                handleClose={handleCloseActions}
                menuItems={sessionMenuItems}
                actionsHeight={'40px'}
                position="left"
                verticalPosition={"top"}
        />
        <ConfirmationPopup
                open={openConfirmationPopup}
                message={`Are you sure you want to Delete this session?`}
                gifData={DeleteGif}
                yesButtonFunctionality={onYesButtonClick}
                noButtonFunctionality={onNoButtonClick}
                messageWidth={'195px'}
        />
        <WarningPopup
          message={warningMessage}
          openWarningPopup={ openWarningPopup }
          closeWarnPopup={ closeWarnPopup }
        />
    </div>
  )
}

export default WorkshopLibrary
